import { render, staticRenderFns } from "./PersonelModal.vue?vue&type=template&id=5223f70c&"
import script from "./PersonelModal.vue?vue&type=script&lang=ts&"
export * from "./PersonelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports